/* eslint-disable */
let hasLoaded = false;

const munchkinFunctionActivation = function() {
  if (window.Munchkin && window.Munchkin.munchkinFunction) {
    window.Munchkin.munchkinFunction('visitWebPage', {
      url: window.location.pathname
    });

    Array.from(document.querySelectorAll('a[href]')).forEach(function(link) {
      if (!link.hash) {
        link.addEventListener('click', function() {
          window.Munchkin.munchkinFunction('clickLink', {
            href: link.getAttribute('href')
          });
        });
      }
    });
  }
};

exports.onInitialClientRender = function() {
  const munchkin = document.createElement('script');
  munchkin.src = '//munchkin.marketo.net/munchkin.js';
  munchkin.async = true;
  munchkin.onload = function() {
    window.Munchkin.init('805-PTZ-019');
    munchkinFunctionActivation();
    hasLoaded = true;
  };

  document.body.appendChild(munchkin);
};

exports.onRouteUpdate = function() {
  // Munchkin isn't made for SPA so we must mimic what it
  // does on landing after any route changes which is to
  // log the visited page and log any clicked links
  if (hasLoaded) {
    munchkinFunctionActivation();
  }
};
